/** Accès ouvert à tous les pros (ex-gate pilote retiré). */
export function canAccessFollowEngine(_email?: string | null): boolean {
  return true;
}

export function animalFollowTab(
  _email: string | null | undefined,
  tabParam: string | null
): 'fiche' | 'suivis' {
  return tabParam === 'suivis' ? 'suivis' : 'fiche';
}
